import { ErrorMessage } from '@hookform/error-message';
import type { FieldErrors, UseFormRegister } from 'react-hook-form-latest';

import { preventNumberScroll } from '@/helpers';

interface RecagingFormData {
  per_cage: number;
  sequencePrefix: string;
  sequenceStarting: string;
}

interface PrefixAndSequenceFormProps {
  register: UseFormRegister<RecagingFormData>;
  errors: FieldErrors<RecagingFormData>;
}

export const PrefixAndSequenceForm: React.FC<PrefixAndSequenceFormProps> = ({ register, errors }) => {
  return (
    <div className="flex">
      <input
        type="text"
        {...register('sequencePrefix')}
        placeholder="ABC"
        className="w-25 mr3"
        style={{ minWidth: '13.5rem' }}
      />
      <input
        type="number"
        onWheel={preventNumberScroll}
        {...register('sequenceStarting', {
          min: { value: 0, message: 'Number must be greater than or equal to 0' },
        })}
        placeholder="123"
        className="w-25 mr3"
        style={{ minWidth: '13.5rem' }}
      />
      <ErrorMessage
        errors={errors}
        name="sequenceStarting"
        render={({ message }) => <small className="mr3 red db pt1">{message}</small>}
      />
    </div>
  );
};
